import React, { ReactElement, useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { confirmRes } from "../../../../api/filling-pile";
import "./index.less";
import "react-photo-view/dist/react-photo-view.css";
import Toast from "../../../../components/toast";
import FullLoading from "../../../../components/full-loading";
import { formateDatePile, getPlatform } from "../../../../utils/common";
import { getInstallProgress } from "../../../../api/filling-pile";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { getLoginInfoPromise, getUrlValue } from "../../../../utils/common";

export default function SurveyReport(): ReactElement {
  const [orderInfo, setOrderInfo] = useState<any>();
  const [surveyInfo, setSurveyInfo] = useState<any>();
  const [userName, setUserName] = useState("");
  const loc = useLocation();
  const params = new URLSearchParams(loc.search);

  const router = useHistory();
  const orderNo: any = params.get("orderNo");
  const uid: any = params.get("uid");
  const setTitle = () => {
    document.title = "勘测报告";
  };
  const surveyFee = () => {
    let sum = 0;
    if (
      surveyInfo.surveySelfFeeProject &&
      surveyInfo.surveySelfFeeProject.length > 0
    ) {
      surveyInfo.surveySelfFeeProject.forEach(item => {
        sum += item.price * item.amount;
      });
      return Math.round(sum * 100) / 100;
    }
    return Math.round(sum * 100) / 100;
  };

  const getErrorMsg = err => {
    FullLoading.hide();
    return {
      text: err.message || "提交失败",
      duration: 2000
    };
  };
  const confirmResult = () => {
    FullLoading.show({
      text: "确认中"
    });
    const param = {
      surveySelfFeeProject: surveyInfo.surveySelfFeeProject,
      predictInstallFee: surveyFee(),
      operateType: "user"
    };
    confirmRes({
      uid,
      name: userName,
      orderNo,
      taskId: orderInfo.taskId,
      equipmentCode: orderInfo.equipmentCode,
      operateCode: "05",
      param
    })
      .then(res => {
        console.log("确认勘测结果");
        FullLoading.hide();
        console.log(res);
        if (res.data.code === 200) {
          router.goBack();
          Toast.show({
            text: "已确认",
            duration: 2000
          });
        }
      })
      .catch(err => {
        FullLoading.hide();
        console.log(err);
        Toast.show(getErrorMsg(err));
      });
  };

  useEffect(() => {
    FullLoading.show({
      text: "加载中"
    });
    const order = getUrlValue("orderNo");
    console.log(order);
    setTitle();
    getLoginInfoPromise()
      .then(res => {
        const phoneModel = getPlatform();
        let name: string = res.username;
        if (phoneModel === "android") {
          name = res.nickname;
        }
        setUserName(name);
      })
      .catch(err => {
        console.log(err);
        FullLoading.hide();
      });
    getInstallProgress({ uid, orderNo })
      .then(res => {
        console.log("res", JSON.parse(res.data.surveyInfo));
        console.log(res.data);
        setOrderInfo(res.data);
        setSurveyInfo(JSON.parse(res.data.surveyInfo));
        FullLoading.hide();
      })
      .catch(err => {
        console.log(err);
        FullLoading.hide();
      });
  }, []);
  return (
    <div className="report">
      <div className="info">
        <div className="info-title" style={{ fontWeight: 700 }}>
          勘测信息
        </div>
        <div className="install-time">
          <div className="text">勘测时间</div>
          <div className="date">
            {orderInfo &&
              formateDatePile(orderInfo.surveyFinishDate).split(" ")[0]}
          </div>
        </div>
        <div className="install-fee">
          <div className="text">预计费用</div>
          <div className="num">{surveyInfo && surveyFee()}元</div>
        </div>
        <div className="tips-text">
          勘测结果不能完全代表最终是否能够成功安装。最终实际施工工程量与勘测工程量可能会有出入。
        </div>
        <div className="photo" style={{ fontWeight: 700 }}>
          现场照片
        </div>
        <PhotoProvider>
          <div className="photo-item">
            {orderInfo &&
              orderInfo.surveyPictureList.map((path, index) => (
                <PhotoView src={path.ossUrl} key={index}>
                  <img src={path.ossUrl} alt="" />
                </PhotoView>
              ))}
          </div>
        </PhotoProvider>
        <div className="auto-confirm">
          {
            orderInfo && JSON.parse(orderInfo.surveyInfo).operateType === 1 ?
              <p>提示:超时未确认,系统已自动确认</p> : ""
          }
        </div>
      </div>
      <div className="btn">
        {orderInfo && orderInfo.orderStatus === "12" ? (
          <button className="report-btn" onClick={confirmResult}>
            确认勘测结果
          </button>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
